import {
  FormControl,
  InputLabel,
  InputBase,
  InputAdornment,
  FormHelperText,
} from '@mui/material';

import styles from './TextField.module.scss';

const TextField = ({
  id,
  label,
  value,
  name,
  size,
  placeholder,
  icon = null,
  helperText,
  onChange,
  onBlur,
  disabled = false,
  sx,
}) => {
  return (
    <FormControl variant="standard">
      {label ? (
        <InputLabel shrink htmlFor={id}>
          {label}
        </InputLabel>
      ) : null}

      <InputBase
        id={id}
        size={size}
        classes={{
          root: styles['MuiInputBase-root'],
          input: styles['MuiInputBase-input'],
          sizeSmall: styles['MuiInputBase-sizeSmall'],
        }}
        name={name}
        value={value}
        placeholder={placeholder}
        sx={sx}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        endAdornment={<InputAdornment position="end">{icon}</InputAdornment>}
      />
      {helperText ? (
        <FormHelperText id="helper-text">{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default TextField;
